<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <div class="mt-n2 px-2 text-center">
      <h2 class="pb-3 text-center" style="line-height: 1.25">Welcome back, 
        <span style="white-space: nowrap;">{{ pro_user.name }}!</span>
      </h2>
      You've already set up your user!  Click the button below so you
      can login.  If you need to change/reset your password, you can do so there.
    </div>
    
    <div class="mt-4 px-2 text-center primary--text">
      <h2>{{ leadMessage }}</h2>
    </div>

    <div class="mt-4 text-center" style="line-height: 1.25">
      <strong>Your account is linked to:
        <span style="white-space: nowrap;">{{ pro_user.pro.business_name }}.</span>
      </strong>
    </div>

    <div class="mt-6 mb-3 d-flex justify-center">
      <v-btn width="60%" type="submit" color="primary" :to="{ name: 'login' }">
        Login
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnclaimedUserView',

  props: ['pro_user'],

  computed: {
    leadMessage() {
      const { lead_count } = this.pro_user
      if (lead_count < 1) 
        return 'Start collecting leads now!'

      if(lead_count == 1) 
        return 'You have a lead waiting!'

      return `You have ${ lead_count } leads waiting.`
    },
  },
}
</script>